import { FC } from 'react';

import { Modal } from '@/components/Modal/Modal';
import { Button } from '@/components/ui/Button/Button';
import { Typography } from '@/components/ui/Typography/Typography.styles';

import * as S from './ConfirmModal.styles';

interface ConfirmModalProps {
  title: string;
  subtitle: string;
  confirmLabel: string;
  cancelLabel: string;
  confirmDataCy?: string;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export const ConfirmModal: FC<ConfirmModalProps> = ({
  title,
  subtitle,
  confirmLabel,
  cancelLabel,
  confirmDataCy,
  onConfirm,
  onCancel
}) => (
  <Modal onClose={onCancel} dataCy="confirm-modal">
    <S.Wrapper>
      <S.ContentWrapper>
        <Typography variant="h4">{title}</Typography>
        <S.Subtitle>{subtitle}</S.Subtitle>
      </S.ContentWrapper>

      <S.ModalActions>
        <Button
          data-cy={`confirm-modal-${confirmDataCy}-button`}
          onClick={onConfirm}
          fullWidth
          size="s"
          variant="modalSecondary"
        >
          {confirmLabel}
        </Button>
        <Button onClick={onCancel} fullWidth size="s" variant="modalPrimary">
          {cancelLabel}
        </Button>
      </S.ModalActions>
    </S.Wrapper>
  </Modal>
);
